import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "Delete a coupon from a specified cart.";
export const method = "DELETE";
export const operationId = "quoteGuestCouponManagementV1RemoveDelete";
export const path = "/V1/guest-carts/{cartId}/coupons";
export interface PathParams {
    cartId: string;
}
export type Response = Response200 | Response400 | ResponseDefault;
export type Response200 = boolean;
export type Response400 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "deleteJSON">;
export function execute(pathParams: PathParams, effects: MinimalEffects): Observable<Response200> {
    return effects.deleteJSON(effects.apiUrl(operationId)(path, pathParams), null, effects.restHeaders({})) as any;
}
